import React, { ChangeEvent, useState } from 'react'

// Components
import VideoPlayer from '@famiryru/react-famiry-video-player'

export default () => {
  const [changeUrlVimeo, setChangeUrlVimeo] = useState<string>(
    'https://vimeo.com/259411563'
  )
  const [changeUrlCustom, setChangeUrlCustom] = useState<string>(
    'https://famiry-edu-userfiles.s3.eu-central-1.amazonaws.com/c0d9a381-dc13-42e8-bde4-2deb33339d87/bD1aq0ybrWytWrL9RdyG1h1028L9qzwCpVCKIhUm.mp4'
  )
  const [urlVimeo, setUrlVimeo] = useState<string>('')
  const [urlCustom, setUrlCustom] = useState<string>('')

  const onChangeUrlVimeo = (event: ChangeEvent<HTMLInputElement>) => {
    setChangeUrlVimeo(event.currentTarget.value)
  }

  const onChangeUrlCustom = (event: ChangeEvent<HTMLInputElement>) => {
    setChangeUrlCustom(event.currentTarget.value)
  }

  const showVideoVimeo = () => {
    setUrlVimeo(changeUrlVimeo)
  }

  const showVideoCustom = () => {
    setUrlCustom(changeUrlCustom)
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        margin: '0 -10px',
        padding: 20,
      }}
    >
      <div style={{ flex: '0 0 50%', padding: '0 10px' }}>
        <h2>Vimeo видео:</h2>
        <input
          type={'text'}
          placeholder={'Ссылка на видео Vimeo'}
          value={changeUrlVimeo}
          onChange={onChangeUrlVimeo}
        />
        <br />
        <button style={{ marginTop: 10 }} onClick={showVideoVimeo}>
          Показать
        </button>
        {urlVimeo ? (
          <VideoPlayer
            url={urlVimeo}
            containerStyle={{
              width: 500,
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
            }}
          />
        ) : null}
      </div>
      <div style={{ flex: '0 0 50%', padding: '0 10px' }}>
        <h2>Custom видео:</h2>
        <input
          type={'text'}
          placeholder={'Ссылка на видео Custom'}
          value={changeUrlCustom}
          onChange={onChangeUrlCustom}
        />
        <br />
        <button style={{ marginTop: 10 }} onClick={showVideoCustom}>
          Показать
        </button>
        {urlCustom ? <VideoPlayer url={urlCustom} /> : null}
      </div>
    </div>
  )
}
